import React, { Component } from "react";
import { bindActionCreators } from "redux";
import { connect } from "react-redux";
import { formDataSaqAep } from "../../data/formDataSaqAep";
import ComponentSaq from "../../components/ComponentSaq";
import { callApiDownloadSaqPdf } from "../../services";
import fetch from "node-fetch";

class Demo extends Component {
  constructor(props) {
    super(props);
    this.props = props;
    this.state = {};
  }

  componentDidMount() {
    callApiDownloadSaqPdf({ saqId: "613f2396d292de0f1b5cca29" })
      .then((res) => {
        //console.log("res", res);
        fetch(process.env.REACT_APP_API_URL + "/" + res.data).then(
          (response) => {
            response.blob().then((blob) => {
              let url = window.URL.createObjectURL(blob);
              let a = document.createElement("a");
              a.href = url;
              a.download = res.data;
              a.click();
            });
          }
        );
      })
      .catch((error) => {
        //console.log("Inside saq download... error", error);
      });
  }

  render() {
    return "Demo download";
  }
}

const mapStateToProps = (state) => {
  return {
    res: state.authStore.res,
  };
};
const mapDispatchToProps = (dispatch) => {
  return bindActionCreators({}, dispatch);
};

export default connect(mapStateToProps, mapDispatchToProps)(Demo);
